import React, { useEffect, useState } from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useNavigate } from 'react-router-dom';

export default function Second() {
    const navigate = useNavigate();
    const destinations = [
        {
            img: '/assets/img/izmir.jpeg',
            name: 'IZMIR',
            lat: 38.4192,
            lng: 27.1287
        },
        {
            img: '/assets/img/gaziantep.jpeg',
            name: 'GAZIANTEP',
            lat: 37.0662,
            lng: 37.3833
        },
        {
            img: '/assets/img/eskisehir.jpeg',
            name: 'ESKISEHIR',
            lat: 39.7767,
            lng: 30.5206
        },
        {
            img: '/assets/img/bursa.jpeg',
            name: 'BURSA',
            lat: 40.1828,
            lng: 29.0665
        }
    ];
    const options = {
        nav: true,
        dots: false,
        autoplay: true,
        loop: true,
        margin: 20,
        responsive: {
            0: { items: 1 },
            600: { items: 3 },
            1000: { items: 4 },
        },
    };

    const handleClick = (lat, lng, name) => {
            const today = new Date();
            today.setDate(today.getDate() + 3);
            const formattedToday = today.toISOString().split('T')[0];
        
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            const formattedTomorrow = tomorrow.toISOString().split('T')[0];
        
            const params = new URLSearchParams();
        
            params.set('checkIn', formattedToday);
            params.set('checkOut', formattedTomorrow);
            params.set('nation', 'SA');
            params.set('lat', lat);
            params.set('lng', lng);
            params.set('lang', 'eng');
            params.set('sourcemarket', 'SA');
            params.set('locationName', name);
    
            // Occupancies bilgisini ekle
            const occupancies = [{
                rooms: 1,
                adults: 2,
                children: 0
            }];
            params.set('occupancies', JSON.stringify(occupancies));
            localStorage.setItem("lat", lat);
            localStorage.setItem("lng", lng);
            navigate(`/hotels?${params.toString()}`);
            window.scrollTo(0, 0);
    };
    
return (
<>
    <section className="section destination-section">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-10 wow fadeInUp text-center" data-wow-delay="0.2s">
                    <div className="section-header text-center">
                        <h2 className="mb-2">Search by Destinations Around the Turkey </h2>
                        <p className="sub-title">Discover the magic of Turkey with Cornleth, your gateway to unforgettable stays and experiences.
                        </p>
                    </div>
                </div>
            </div>
            <OwlCarousel className="owl-carousel destination-slider nav-center" {...options}>
            {destinations.map((destination, index) => (
                <div style={{ height:'300px' }} key={index} className="destination-item wow fadeInUp mb-4" data-wow-delay="0.2s">
                <img src={destination.img} style={{ height:'300px', objectFit:'cover' }} alt={destination.name} onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()} />
                <div className="destination-info text-center">
                    <div className="destination-content">
                    <h5 className="mb-1 text-white">{destination.name}</h5>
                    <div className="d-flex align-items-center justify-content-center">
                    </div>
                    </div>
                    
                </div>
                <a onClick={() => handleClick(destination.lat, destination.lng, destination.name)} className="overlay-circle-link">
                    <i className="isax isax-arrow-right-1"></i>
                </a>
                </div>
            ))}
            </OwlCarousel>
        </div>
    </section>
</>
)
}
